import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormInput } from 'components/AntEnhancement/FormControls';
import localeTranslator from 'library/Hocs/LocalTranslator';
import './style.css';
var DocumentForm = function (props) {
    var t = props.translate;
    var onChangeName = function (event) {
        props.document.setName(event.target.value);
    };
    return (_jsx("div", { className: "doc-form", children: _jsxs("div", { className: "doc-form__field", children: [_jsxs("label", { className: "doc-form__label", htmlFor: "name", children: [t('name'), " ", _jsx("span", { className: "doc-form__req", children: "*" })] }), _jsx(FormInput, { label: t('name'), name: "name", placeHolder: t('namePlaceholder'), rules: [{ required: true, whitespace: true, message: t('errors.name') }], onChange: onChangeName, initialValue: props.document.getName() }), _jsx("p", { className: "doc-form__hint", children: t('nameHint') })] }) }));
};
export default localeTranslator(DocumentForm, 'documentForm');
